<h2 mat-dialog-title class="ml-80">{{'Cargando' | translate}} ...</h2>

<mat-dialog-content>
  <mat-progress-spinner class="ml-80" [color]="color" [mode]="mode" [value]="value">
  </mat-progress-spinner>
</mat-dialog-content>
